import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="reload"
export default class extends Controller {
  static values = { delay: { type: Number, default: 2000 } } // Default delay 2 seconds

  connect () {
    this.timeout = setTimeout(() => {
      window.location.reload()
    }, this.delayValue)
  }

  disconnect () {
    // Clear the timeout if the controller is disconnected before the reload happens
    // (e.g., user navigates away)
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}
